import { AbstractControl, FormControl, ValidatorFn, Validators } from '@angular/forms';
import { CartLine } from '@next/core-lib/cart';
import { TableColumn, TableColumnTypes } from '@next/core-lib/table';
import { CartColumns } from 'src/app/cart/models/app.models';

import { createQuantityUnitSuffixArray } from './create-quantity-unit-suffix';
import { CartComponent } from '../../cart.component';

const decorateReturnableFormControl = (row: CartLine, formControl: FormControl): void => {
  const validators = Array<ValidatorFn>(Validators.min(1), Validators.required);

  if (row?.returnInformation?.returnableQuantity) {
    validators.push(Validators.max(row.returnInformation.returnableQuantity));
  }

  formControl.setValidators(validators);
};

export const createReturnOrderColumns = (componentRef: CartComponent): TableColumn[] => {
  const createSuffix = (line: CartLine): string => {
    const separator = componentRef.locale.translate('cart.cart-quantity-separator');
    const returnableQuantity = line.returnInformation?.returnableQuantity;
    const orderUnit = componentRef.locale.translate(`unit.${line?.orderingInformation?.orderUnit}`);

    return line.returnInformation ? `${separator} ${returnableQuantity} ${orderUnit}` : '';
  };

  const columns: TableColumn[] = [
    {
      id: CartColumns.skuTitle,
      type: TableColumnTypes.TEMPLATE,
      label: `cart.cart-column-${CartColumns.skuTitle}`,
      template: componentRef.columnSkuTitleRef.instance.template,
      className: 'flex__child--2',
      headerClassName: 'flex__child--2',
      disableSort: true,
    },
    {
      id: CartColumns.quantity,
      type: componentRef.editable ? TableColumnTypes.INPUT_NUMBER : TableColumnTypes.NUMBER,
      label: `cart.cart-column-${CartColumns.quantityAndUnitInformation}`,
      inputConfig: componentRef.editable && {
        callback: (row: CartLine, control: AbstractControl) => componentRef.debounceQuantityChange$.next({ row, control }),
        formArray: componentRef.orderQuantities,
        decorateFormControl: decorateReturnableFormControl,
        suffixArray: componentRef.cart?.lines ? componentRef.cart.lines.map(createSuffix) : [],
      },
      numberConfig: !componentRef.editable && {
        suffixArray: createQuantityUnitSuffixArray(componentRef),
      },
      className: 'flex__child--2 spacing--padding-half-vertical',
      headerClassName: 'flex__child--2',
      disableSort: true,
    },
    {
      id: CartColumns.externalInvoiceIdForReturn,
      type: TableColumnTypes.TEMPLATE,
      label: `cart.cart-column-${CartColumns.externalInvoiceIdForReturn}`,
      template: componentRef.columnExternalInvoiceIdForReturnRef.instance.template,
      className: 'flex__child--2',
      headerClassName: 'flex__child--2',
      disableSort: true,
    },
  ];

  return columns;
};
